<template>
  <el-col :span="24">
    <!-- <el-col :span="4" style="text-align: right;margin-top: 20px;margin-bottom: 20px;">
      <el-select style="width: 90%;" v-model="people_source_value"  placeholder="请选择">
        <el-option v-for="item in user_source"  :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </el-col>
    <el-col :span="4" style="text-align: right;margin-top: 20px;margin-bottom: 20px;">
      <el-select style="width: 90%;"  v-model="payment_method_value"  placeholder="请选择">
        <el-option v-for="item in payment_method_agent"  :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
    </el-col> -->
    <el-col :span="10" style="margin-top: 20px;display: flex;text-align: left;align-items: baseline;">
      目标：
      <el-input style="width: 150px;" :disabled="is_disabled==1?true:false" v-model="achievement" placeholder="请填写业绩"></el-input>
      <el-button  style="margin: 0 auto;margin-left: 10px;margin-bottom: 10px;width: 100px;"  type="warning" @click="modify_information" >{{is_disabled==1?'修改':"保存"}}</el-button>
      <span>实收除于目标：{{achievement==0?0:(paid_amount_sum1/achievement*100).toFixed(2)}}%</span>
      <el-button type="danger" style="margin: 0 auto;margin-left: 10px;margin-bottom: 10px;width: 100px;" @click="DailyPaper">查看日报</el-button>
    </el-col>
    <el-col :span="7" style="text-align: right;margin-top: 20px;">
      <ComponentDatePicker ref="ComponentDatePicker"></ComponentDatePicker>
    </el-col>
    <el-col :span="2" style="text-align: center;margin-top: 20px;">
      <el-button type="primary" @click="month_time">按本月查询</el-button>
    </el-col>
    <el-col :span="2" style="text-align: center;margin-top: 20px;">
      <el-button type="danger" @click="ostentation_time">按时间查询</el-button>
    </el-col>

    <el-col :span="24" style="text-align: center;">
      <div style="text-align: left;line-height: 50px;text-indent: 5px;color: #909399;">
        统计：
        <span style="color: rgb(77 175 213);">总实收：{{(paid_amount_sum1+goods_sell[0].net_receipts).toFixed(2)}}</span>&nbsp;&nbsp;||&nbsp;&nbsp;
        <span style="color: rgb(77 175 213);">未退款：实收金额：{{(paid_amount_sum1).toFixed(2)}}</span>&nbsp;&nbsp;||&nbsp;&nbsp;
        <span style="color: rgb(195 133 184);">未退款：人数：{{people_sum1}}</span>&nbsp;&nbsp;||&nbsp;&nbsp;
        <span style="color: rgb(214 197 73);">未退款：补差价：{{turnover_sum1}}</span>&nbsp;&nbsp;||&nbsp;&nbsp;

        <span style="color: rgb(77 175 213);">已退款：实收金额：{{paid_amount_sum2}}</span>&nbsp;&nbsp;||&nbsp;&nbsp;
        <span style="color: rgb(195 133 184);">已退款：人数：{{people_sum2}}</span>&nbsp;&nbsp;||&nbsp;&nbsp;
        <span style="color: rgb(214 197 73);">已退款：补差价：{{turnover_sum2}}</span>&nbsp;&nbsp;||&nbsp;&nbsp;


        <span style="color: rgb(214 197 73);">前厅售卖：数量：{{goods_sell[0].cnt}}</span>&nbsp;&nbsp;||&nbsp;&nbsp;
        <span style="color: rgb(214 197 73);">实收：{{goods_sell[0].net_receipts}}</span>
      </div>
    </el-col>
    <el-col :span="12" >
        <el-col  style="width: 90%;margin-top: 10px;text-align: left;margin-bottom: 10px;">
          未退款
        </el-col>
        <el-table :data="
          tableData1.filter(
            (data) =>
              !search || data.name.toLowerCase().includes(search.toLowerCase())
          )
        "
        border
        :summary-method="getSummaries"
        show-summary
         style="width: 90%"
         >
          </el-table-column>
          <el-table-column label="用户来源"  prop="people_source">
            <template slot-scope="scope">
              {{user_source.find(item => item.value==scope.row.people_source).label}}
            </template>
          </el-table-column>
          <el-table-column label="付款方式"  prop="payment_mode">
            <template slot-scope="scope">
              {{payment_method_agent.find(item => item.value==scope.row.payment_mode).label}}
            </template>
          </el-table-column>
          <el-table-column label="实收金额"  prop="net_receipts">
            <template slot-scope="scope">
              {{(scope.row.net_receipts).toFixed(2)}}
            </template>
          </el-table-column>
          <el-table-column label="人数"  prop="people_count">
            <template slot-scope="scope">
              {{scope.row.people_count}}
            </template>
          </el-table-column>
          <el-table-column label="补差价类型"  prop="extra_money_type">
            <template slot-scope="scope">
              {{extra_money_list.find(item => item.value==scope.row.extra_money_type).label}}
            </template>
          </el-table-column>
          <el-table-column label="补差价"  prop="extra_money">
            <template slot-scope="scope">
              {{scope.row.extra_money}}
            </template>
          </el-table-column>
        </el-table>
    </el-col>
    <el-col :span="12" >
        <el-col style="margin-top: 10px;text-align: left;margin-bottom: 10px;width: 90%">
          已退款
        </el-col>
        <el-table :data="
          tableData3.filter(
            (data) =>
              !search || data.name.toLowerCase().includes(search.toLowerCase())
          )
        "
        :summary-method="getSummaries"
        show-summary
        border
         style="width: 90%"
         >
         </el-table-column>
          <el-table-column label="用户来源"  prop="people_source">
            <template slot-scope="scope">
              {{user_source.find(item => item.value==scope.row.people_source).label}}
            </template>
          </el-table-column>
          <el-table-column label="付款方式"  prop="payment_mode">
            <template slot-scope="scope">
              {{payment_method_agent.find(item => item.value==scope.row.payment_mode).label}}
            </template>
          </el-table-column>
          <el-table-column label="实收金额"  prop="net_receipts">
            <template slot-scope="scope">
              {{scope.row.net_receipts}}
            </template>
          </el-table-column>
          <el-table-column label="人数"  prop="people_count">
            <template slot-scope="scope">
              {{scope.row.people_count}}
            </template>
          </el-table-column>
          <el-table-column label="补差价类型"  prop="extra_money_type">
            <template slot-scope="scope">
              {{extra_money_list.find(item => item.value==scope.row.extra_money_type).label}}
            </template>
          </el-table-column>
          <el-table-column label="补差价"  prop="extra_money">
            <template slot-scope="scope">
              {{scope.row.extra_money}}
            </template>
          </el-table-column>
        </el-table>
    </el-col>
    <el-col :span="12" >
        <el-col style="margin-top: 10px;text-align: left;margin-bottom: 10px;width: 90%">
          未退款：用户来源汇总
        </el-col>
        <el-table :data="
          people_source_data.filter(
            (data) =>
              !search || data.name.toLowerCase().includes(search.toLowerCase())
          )
        "
        border
         style="width: 90%"
         >
         </el-table-column>
          <el-table-column label="用户来源"  prop="people_source">
            <template slot-scope="scope">
              {{user_source.find(item => item.value==scope.row.id).label}}
            </template>
          </el-table-column>
          <el-table-column label="实收金额"  prop="net_receipts">
            <template slot-scope="scope">
              {{number_and(scope.row.child,1).toFixed(2)}}
            </template>
          </el-table-column>
          <el-table-column label="总人数"  prop="net_receipts">
            <template slot-scope="scope">
              {{number_and(scope.row.child,2)}}
            </template>
          </el-table-column>
        </el-table>
    </el-col>
    <el-col :span="12" >
        <el-col style="margin-top: 10px;text-align: left;margin-bottom: 10px;width: 90%">
          未退款：支付方式汇总
        </el-col>
        <el-table :data="
          payment_mode_data.filter(
            (data) =>
              !search || data.name.toLowerCase().includes(search.toLowerCase())
          )
        "
        border
         style="width: 90%"
         >
         </el-table-column>
         <el-table-column label="付款方式"  prop="payment_mode">
           <template slot-scope="scope">
             {{payment_method_agent.find(item => item.value==scope.row.id).label}}
           </template>
         </el-table-column>
          <el-table-column label="实收金额"  prop="net_receipts">
            <template slot-scope="scope">
              {{number_and(scope.row.child,1).toFixed(2)}}
            </template>
          </el-table-column>
          <el-table-column label="总人数"  prop="net_receipts">
            <template slot-scope="scope">
              {{number_and(scope.row.child,2)}}
            </template>
          </el-table-column>
        </el-table>
    </el-col>
    <el-drawer
       title="我是标题"
       :visible.sync="dailyPaperdrawer"
       size="60%"
       :with-header="false">
         <span v-html="this.dailyPaperdrawerMes" style="text-align: left" ></span>

    </el-drawer>
  </el-col>
</template>

<script>
  import {
    protocol_dailyPaper,
    protocol_ZgrShopOstentationOrderDetail_shop_simple_statistics,
    protocol_ZgrShopAchievement_achievement_get,
    protocol_ZgrShopAchievement_achievement_set
  } from '@/assets/js/network/request'
  import {
    gUtilityTime
  } from '@/assets/js/utility/UtiltiyTime'
  import {
    gGameData
  } from '@/assets/js/data/GameData'
  import {
      gUtilityExcel
    } from "@/assets/js/utility/UtilityExcel";
  import ComponentDatePicker from "@/components/ComponentDatePicker";
  import payment_methodagent from "@/assets/js/payment_methodagent.json";
  import {
    gAccount
  } from '@/assets/js/data/Account'
  export default {
    components: {
      ComponentDatePicker
    },
    data() {
      return {
        is_disabled:1,
        achievement:0,
        tableData1: [],
        multipleSelection: [],
        multipleSelection2: [],
        multipleSelection3: [],
        multipleSelection4: [],
        tableData3: [],
        search: '',
        extra_money_list:[
          {
            value: 1,
            label: '支付宝',
          },{
          value: 2,
          label: '微信',
          },
        ],
        people_source_value:1,
        user_source:[{
          value: 1,
          label: '线下路过',
        }, {
          value: 2,
          label: '电话预定'
        }, {
          value: 3,
          label: '业务招待'
        }, {
          value: 4,
          label: '线上预订-大众点评/美团'
        }, {
          value: 5,
          label: '线上团购-大众点评/美团'
        }, {
          value: 6,
          label: '线上预订-口碑团购'
        }, {
          value: 7,
          label: '线上预订-b站'
        }, {
          value: 8,
          label: '线上预订-猫眼'
        }, {
          value: 9,
          label: '线上预订-抖音'
        },{
          value: 10,
          label: '微盟'
        },{
          value: 11,
          label: '其他'
        },{
          value: 12,
          label: '私域'
        },{
          value: 13,
          label: '小程序'
        }],
        payment_method_value:1,
        payment_method_agent:[],
        paid_amount_sum1:0,
        people_sum1:0,
        turnover_sum1:0,
        paid_amount_sum2:0,
        people_sum2:0,
        turnover_sum2:0,

        totle_shishou1:0,
        totle_renshu1:0,
        totle_chajia1:0,
        totle_shishou2:0,
        totle_renshu2:0,
        totle_chajia2:0,
        totle_shishou3:0,
        totle_renshu3:0,
        totle_chajia3:0,
        totle_shishou4:0,
        totle_renshu4:0,
        totle_chajia4:0,
        loading:"",
        people_source_data:[],
        payment_mode_data:[],
        goods_sell:[{net_receipts:0,cnt:0}],
        dailyPaperdrawer:false,
        dailyPaperdrawerMes:''
      }
    },
    methods: {
      modify_information(){
        let _this=this;
        if(this.is_disabled==1){
          this.is_disabled=0
        }else{
          if(this.achievement==""){
            this.$message({
              message: '业绩不能为空',
              type: 'warning',
            });
            return
          }
          protocol_ZgrShopAchievement_achievement_set(this.achievement).then(res=>{
            _this.$message({
              message: '提交成功',
              type: 'success',
            });
            _this.is_disabled=1;
          })
        }
      },

      DailyPaper(){
        let _this=this;
           _this.dailyPaperdrawer=true;
           _this.dailyPaperdrawerMe='';
          protocol_dailyPaper().then(res=>{
            _this.$message({
              message: '成功',
              type: 'success',
            });
            _this.dailyPaperdrawerMes=res.ret;
          })
      },

      number_and(e,type){
        let number=0;
        for(let i=0;i<e.length;i++){
          if(type==1){
            number+=Number(e[i].net_receipts)
          }else if(type==2){
            number+=Number(e[i].people_count)
          }else if(type==3){
            number+=Number(e[i].extra_money)
          }
        }
        return number
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总价';
            return;
          }
          if (index === 1) {
            sums[index] = 'N/A';
            return;
          }
          if (index === 4) {
            sums[index] = 'N/A';
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] ;
          } else {
            sums[index] = 'N/A';
          }
        });

        return sums;
      },
      game_name(id){
        return gGameData.getDataByID(id)
      },
      ret_YearMonthDate(time){
        return gUtilityTime.YearMonthDate(time,1)+gUtilityTime.YearMonthDate(time,2)+gUtilityTime.YearMonthDate(time,3)
      },
      ret_YearMonthDateHoursMin(time){
        return gUtilityTime.YearMonthDate(time,4)+gUtilityTime.YearMonthDate(time,5)
      },
      ostentation_time(){
        this.init(gUtilityTime.startTime(this.$refs.ComponentDatePicker.get_time_start())/1000,gUtilityTime.endTime(this.$refs.ComponentDatePicker.get_time_end())/1000)
      },
      month_time(){
        this.init(this.getTimeStamp().startTime,this.getTimeStamp().endTime)
      },
      //获取当前月的第一天和最后一天时间戳
      getTimeStamp() {
        let inDate = new Date();
        let year = inDate.getFullYear();
        let month = inDate.getMonth();
        var date = new Date();
        var currentMonth = date.getMonth();
        let startTime = new Date(year, month, 1).getTime();
        let endTime = "";
        if (month == currentMonth) {
         //当前月
         //如果当前日期是本月的情况下,那么将获取当天23:59:59的时间戳
          endTime =
            new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 - 1; //当天23:59:59时间戳
          console.log("当前月");
        } else {
          //不是当前月的情况下
          endTime = new Date(year, month + 1, 1).getTime() - 1;
          //当月最后一天23:59:59时间戳
        }
      return {
         startTime: startTime/1000,
         endTime: parseInt(endTime/1000)
        }

      },
      //打开全局等待框
      open_wait_for(type){
        if(type==1){
          let loading = this.$loading({
                  lock: true,
                  text: '请求中，请耐心等待',
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)',
           });
           this.loading=loading;
        }else{
          this.loading.close();
        }
      },
      init(time_start,time_end) {
        let _this=this;
        let date=new Date();
        if(time_start==undefined){
          time_start=gUtilityTime.YesterDayday((date.getTime()) - (1000*60*60*24),1);
          time_end=gUtilityTime.YesterDayday((date.getTime()) - (1000*60*60*24),2);
        }
        this.open_wait_for(1);
        protocol_ZgrShopOstentationOrderDetail_shop_simple_statistics(time_start,time_end).then(res=>{
          this.open_wait_for(2);
          let tableData1=[],tableData3=[];
          let paid_amount_sum1=0,people_sum1=0,turnover_sum1=0,paid_amount_sum2=0,people_sum2=0,turnover_sum2=0;
          for(let i=0;i<res.ret.no_refund_order.length;i++){
            paid_amount_sum1+=Number(res.ret.no_refund_order[i].net_receipts);
            people_sum1+=Number(res.ret.no_refund_order[i].people_count);
            turnover_sum1+=Number(res.ret.no_refund_order[i].extra_money);
            tableData1.push(res.ret.no_refund_order[i])
          }
          for(let i=0;i<res.ret.refund_order.length;i++){
            paid_amount_sum2+=Number(res.ret.refund_order[i].net_receipts);
            people_sum2+=Number(res.ret.refund_order[i].people_count);
            turnover_sum2+=Number(res.ret.refund_order[i].extra_money);
            tableData3.push(res.ret.refund_order[i])
          }
          _this.tableData1=tableData1;
          _this.tableData3=tableData3;
          this.paid_amount_sum1=paid_amount_sum1;
          this.people_sum1=people_sum1,
          this.turnover_sum1=turnover_sum1,
          this.paid_amount_sum2=paid_amount_sum2,
          this.people_sum2=people_sum2,
          this.turnover_sum2=turnover_sum2;
          this.goods_sell=res.ret.goods_sell;


          let newsas = Array.from(
            tableData1.reduce((dict, item)=> {
              if (dict.has(item.people_source)) {
                dict.get(item.people_source).push(item)
              } else {
                dict.set(item.people_source, [item])
              }
              return dict
            }, new Map())
          ).map(item => ({child: item[1], id: item[0]}))
          let newsas1 = Array.from(
            tableData1.reduce((dict, item)=> {
              if (dict.has(item.payment_mode)) {
                dict.get(item.payment_mode).push(item)
              } else {
                dict.set(item.payment_mode, [item])
              }
              return dict
            }, new Map())
          ).map(item => ({child: item[1], id: item[0]}))
          _this.people_source_data=newsas;
          _this.payment_mode_data=newsas1;
          console.log(newsas)
          console.log(newsas1)
        })
      }
    },
    mounted() {
      let _this=this;
      protocol_ZgrShopAchievement_achievement_get().then(res=>{
        _this.achievement=res.ret.length==0?0:res.ret[0].achievement_data
      })
      this.payment_method_agent = payment_methodagent;
      this.init()
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Statistics.vue